// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-form .el-table .cell .el-form-item__content[data-v-2966cad1] {\n  line-height: normal;\n}\n.dialog[data-v-2966cad1]  .el-input-group__append {\n  padding: 0 10px;\n}\n.dialog[data-v-2966cad1]  .el-table .el-form-item {\n  margin-bottom: 10px;\n}\n.dialog[data-v-2966cad1]  .el-input__suffix {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}", ""]);
// Exports
module.exports = exports;
